<template>
  <div class="article-detail-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" :title="title" :showBack="true"></my-header>
    <div class="article-title">{{article.title}}</div>
    <div class="article-operate-part border-bottom-style">
      <div v-if="article.createTime">{{article.createTime | longTime}}</div>
      <div class="operate-favorite" v-if="!isFavoriteArticle" @click="favoriteArticle">
        <img  src="../../assets/icon/favorite-icon.png">
      </div>
      <div class="operate-favorite" v-if="isFavoriteArticle" @click="cancelFavoriteArticle">
        <img src="../../assets/icon/favorited-icon.png">
      </div>
    </div>
    <div class="article-content" v-html="article.content"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import articleService from '../../service/article/ArticleService'
  import favoriteService from '../../service/customer/FavoriteService'
  import {imgUrl,shareIcon} from "../../config";
  import shareService from '../../service/share/ShareService'
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'ArticleDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        articleId:'',
        article:{},
        isFavoriteArticle:false,
        title:'文章详情',
        summary:'',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    created(){
      this.articleId = this.$route.query.articleId;
      this.title = this.$route.query.title || '文章详情';
    },
    beforeMount () {
      this.loadArticleDetail();
      session.isLogin().then(flag => {
        if(flag){
          this.checkFavoriteArticle();
        }
      });
    },
    methods: {
      async loadArticleDetail(){
        let {code,msg,data} = await articleService.detail(this.articleId);
        if(code == '0'){
          this.article = data;
          if(this.article.title){
            this.title = this.article.title;
            this.summary = this.article.summary;
            this.initWechatShare();
            document.title = this.title;
          }
        }else {
          Toast(msg);
        }
      },
      async checkFavoriteArticle(){
        let {code,msg,data} = await favoriteService.favoriteCheck(this.articleId,'3');
        if(code == '0'){
          this.isFavoriteArticle = data;
        }else {
          Toast(msg);
        }
      },
      async favoriteArticle(){
        const isLogin = await session.isLogin();
        if(isLogin){
          let {code,msg,data} = await favoriteService.addFavorite(this.articleId,'3');
          if(code == '0'){
            this.isFavoriteArticle = !this.isFavoriteArticle;
            Toast('文章收藏成功!');
          }else {
            Toast('文章收藏失败!');
          }
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }

      },
      async cancelFavoriteArticle(){
        let {code,msg,data} = await favoriteService.removeFavorite(this.articleId,'3');
        if(code == '0'){
          this.isFavoriteArticle = !this.isFavoriteArticle;
          Toast('文章取消收藏成功!');
        }else {
          Toast('文章取消收藏失败!');
        }
      },
      async initWechatShare(){
        let title = this.title;// 分享标题
        let desc = this.summary; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .article-detail-view {
    background: white;
    font-size: 0.28rem;
    word-break: break-all;
    .article-cover{
      width: 100%;
      display: flex;
    }
    .article-title{
      font-size: 0.36rem;
      font-weight: bold;
      color: #191818;
      word-wrap:break-word;
      padding: 0.24rem 0.3rem 0.24rem 0.25rem;
    }
    .article-operate-part{
      width: 6.9rem;
      font-size: 0.24rem;
      color: #cecbca;
      display: flex;
      justify-content: space-between;
      padding: 0 0 0.2rem 0;
      margin-left: 0.3rem;
      .operate-favorite{
        display: flex;
      }
      img{
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
      }
    }
    .article-content{
      margin-top: 0.3rem;
      padding: 0 0.3rem 0.5rem;
      font-size: 0.32rem;
      line-height: 0.5rem;
      color: #7f7d7c;
      img{
        width: 100%;
      }
      p{
        width: 6.9rem !important;
      }
    }
  }
</style>
